import React from 'react';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import formatNumber from 'helpers/formatNumber';
import { ABBREVIATION_THRESHOLD } from 'helpers/abbreviateNumber';
import { Label } from './shared.style';
import { Value, StyledChangeArrow, ItemWrapper } from './shared.style';

interface IKPIListItemProps {
  label: string;
  metric: any;
  isMobileView: boolean;
}

const KPIRedesignedListItem: React.FC<IKPIListItemProps> = (props) => {
  const { label, metric, isMobileView } = props;
  const valueObject = metric.value[0];

  const { type: valueType, value } = valueObject;
  const isFull =
    isMobileView && valueType !== 'trend' && valueType !== 'percentage';

  let displayValue = value;
  let fullValue = value;

  if (displayValue === null || typeof value === 'number') {
    displayValue = formatNumber(value, isFull ? 'full' : valueType, true);
    fullValue = formatNumber(value, isFull ? 'full' : valueType, false);
  }

  const isPositive = value > 0;

  return (
    <ItemWrapper isMobileView={isMobileView}>
      <Label>
        <>
          {valueType === 'trend' && isMobileView && (
            <StyledChangeArrow
              isPositive={isPositive}
              isMobileView={isMobileView}
            >
              <span aria-hidden>{isPositive ? '▲' : '▼'}</span>
            </StyledChangeArrow>
          )}
          {label === 'Skip rate' ? (
            <TippyToolTip
              tooltipContent={
                'Skip rate includes tracks streamed between 30 and 60 seconds. So the "skips" are only skips reported after 30 seconds and before 1 minute.'
              }
              placement="bottom-start"
              maxWidth="445px"
              withDashedLine
              enabled
            >
              {label}
            </TippyToolTip>
          ) : (
            label
          )}
        </>
      </Label>
      <Value>
        {valueType === 'trend' && (
          <StyledChangeArrow isPositive={isPositive}>
            {!isMobileView ? (
              <>
                <span aria-hidden>{isPositive ? '▲' : '▼'}</span> {displayValue}
              </>
            ) : (
              displayValue
            )}
          </StyledChangeArrow>
        )}
        {valueType !== 'trend' && (
          <TippyToolTip
            enabled={Math.abs(value) >= ABBREVIATION_THRESHOLD}
            tooltipContent={fullValue}
            canBeCopied
          >
            {displayValue}
          </TippyToolTip>
        )}
      </Value>
    </ItemWrapper>
  );
};

export default KPIRedesignedListItem;
